import React from 'react';
import './_import-empty-search.scss';
import './_import-empty-search.dark-mode.scss';
import { useSelector } from 'react-redux';
import { ReactComponent as NoResult } from './noresult.svg';
import { ReactComponent as NoResultDarkMode } from './noresult-dark-mode.svg';

const ImportEmptySearchServices = () => {
  const { darkMode } = useSelector((state) => state.general);
  return (
    <div className="services-import__empty-search">
      <div>
        <div className="services-import__empty-search-icon">
          {darkMode ? <NoResultDarkMode /> : <NoResult /> }
        </div>
        <div className="services-import__empty-search-description">
          Nothing found
        </div>
      </div>
    </div>
  )
}

ImportEmptySearchServices.propTypes = {

}

export default ImportEmptySearchServices;
